import { compose, filter, lte, path } from 'ramda'

const createdAfterFilter = (thresholdTimestamp, items) => filter(
  compose(lte(thresholdTimestamp), path(['createdOn'])),
  items,
)

export default createdAfterFilter
